
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AppService } from '../../../services';
import { AppStateHolder } from '../../../shared';
import { UserActivitiesService } from './user-activities.service';

@Component({
    selector: 'search',
    templateUrl: 'party-search.component.html',
    host: {
        '(document:click)': 'handleClick($event)'
    },
    standalone: true,
    imports: [FormsModule, TranslateModule]
})

export class SearchComponent implements OnInit {
  private translator = inject(TranslateService);
  private service = inject(UserActivitiesService);
  appStateHolder = inject(AppStateHolder);
  private sharedService = inject(AppService);


  parties: any[];
  searchTerm = new String;
  status: string = 'ok';
  partyStatus = [
    {
      value: false,
      name: "widgets.party-search.active"
    },
    {
      value: true,
      name: "widgets.party-search.terminated"
    },
    {
      value: null,
      name: "widgets.party-search.both"
    },
  ];

  searchTypes: String[];
  savePreference: Boolean;

  currentState: any;
  hideResults: Boolean;

  relTypologies: RelationTypology[];
  preferredTypes: RelationTypology[];

  errorDisplay: boolean = false;
  errorMessage: string;

  @Input() subjectId: any;

  @Input() hideDetails: Boolean;
  @Input() hideSettings: Boolean;

  @Input() smallMode: Boolean;
  @Output() select: EventEmitter<any> = new EventEmitter();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  ngOnInit(): void {

    this.currentState = this.partyStatus[0];
    this.loadRelationTypologies();
  }

  handleClick(event) {

    this.hideResults = true;
  }

  search(): void {

    this.status = 'busy';
    if (this.searchTerm && this.searchTerm.length < 3) {

      this.parties = null;
      this.status = 'ok';
      return;
    }

    this.hideResults = false;

    this.service
      .search(this.searchTerm,
        this.currentState.value, this.searchTypes, this.subjectId)
      .subscribe(result => {
        this.parties = result
        this.status = 'ok'
      });
  }

  selectParty(party: any): void {

    this.select.next(party);
  }

  changeState(state: any): void {

    this.currentState = state;
  }

  errorClose() {
    this.errorDisplay = false;
    this.errorMessage = '';
  }

  onConfirmOptions(): void {

    this.searchTypes = new Array<String>();

    let selectedItems = this.relTypologies.filter(t => {

      return t.selected === true
    });

    let items = selectedItems.map((r) => { return r.id; })

    this.searchTypes = this.searchTypes.concat(items);

    selectedItems = this.preferredTypes.filter(t => {
      return t.selected === true
    });

    items = selectedItems.map((r) => { return r.id; })

    this.searchTypes = this.searchTypes.concat(items);

    if (this.savePreference) {

      this.service
        .savePreferredTypologies(this.searchTypes)
        .then(() => this.loadRelationTypologies())
        .catch((error: any) => {

          if (error.status == 400) {
            this.errorDisplay = true;
            this.errorMessage = this.translator.instant("app.unexpectedError");
          }
          else {
            this.errorDisplay = true;
            this.errorMessage = error.statusText;
          }
        });
    }
  }

  loadRelationTypologies(): void {

    this.service.getRealtionTypologies().subscribe(res => {

      this.relTypologies = new Array<RelationTypology>();

      res.forEach(t => {

        this.relTypologies.push(new RelationTypology(t.relationTypology));
      });

      this.searchTypes = new Array<String>();
      this.preferredTypes = new Array<any>();

      this.sharedService.getUser()
        .subscribe(user => {

          user.relationTypologies.forEach(t => {

            let i = this.relTypologies.find(r => r.id == t)

            i.selected = true;

            this.preferredTypes.push(i);
            this.searchTypes.push(i.id);

          });
        });
    });
  }
}

class RelationTypology {

  id: string;
  name: string;
  selected: Boolean;

  constructor(private t: any) {

    this.id = t.id;
    this.name = t.name;
    this.selected = false;
  }
}
